import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Grid, Typography } from "@material-ui/core";
import { Progress } from "semantic-ui-react";
import UserInfo from "../../model/userInfo";

const useStyles = makeStyles(() => ({
    col3: {
        width: "33%",
    },
    barLeft: {
        height: "5px",
        margin: ".25rem !important",
        marginRight: "auto !important",
    },
    barRight: {
        height: "5px",
        margin: ".25rem !important",
        marginLeft: "auto !important",
    },
    avatar: {
        width: "40px",
        height: "40px",
        margin: ".25rem",
    },
    avatarLeft: {
        display: "flex",
        alignItems: "center",
        float: "left",
        width: "100%",
    },
    avatarRight: {
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "center",
        float: "right",
        width: "100%",
    },
    usernameOverflow: {
        whiteSpace: "nowrap",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    usernameRight: {
        textAlign: "right",
    },
}));

type ProgressBarProps = {
    player: UserInfo,
    percentage: number,
    left: boolean,
}

export default function ProgressbarGame({ player, percentage, left }: ProgressBarProps): JSX.Element {

    const classes = useStyles();
    return (
        <Grid className={classes.col3}>
            <Progress percent={percentage} color="green" className={left ? classes.barLeft : classes.barRight} id={left ? "" : "Mirror"} />
            <div className={left ? classes.avatarLeft : classes.avatarRight}>
                <Avatar
                    alt={player.name}
                    src={player.image}
                    className={classes.avatar}
                />
                <Typography variant="h6" className={`${classes.usernameOverflow} ${left ? "" : classes.usernameRight}`}>
                    {player.username}
                </Typography>
            </div>
        </Grid>
    );
}
